module.exports = __webpack_public_path__ + "img/product-3-sleep.34fb469d.png";